import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { YM_HIDE_CONTENT } from '@/shared/constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneOutput',
  props: {
    input: null,
    withoutParenthesis: {
      type: Boolean
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var output = computed(function () {
      if (!props.input) {
        return props.empty;
      }
      var regex = /(\d)(\d{3})(\d{3})(\d{2})(\d{2})/;
      if (props.withoutParenthesis) {
        return props.input.replace(regex, '$1 $2 $3-$4-$5');
      }
      return props.input.replace(regex, '$1 ($2) $3-$4-$5');
    });
    return {
      __sfc: true,
      props: props,
      output: output,
      YM_HIDE_CONTENT: YM_HIDE_CONTENT
    };
  }
});